
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.5 0l.472 1.506H12.5l-1.237.962.473 1.52-1.236-.922L9.262 4l.474-1.534-1.236-.96h1.528L10.5 0zm2 1.506h1.529L14.5 0l.472 1.506H16.5l-1.236.962.474 1.52-1.238-.922L13.264 4l.473-1.534-1.237-.96zm1.611 6.985c.851-2.194-.094-3.55-1.125-3.489-.944.056-2.02 1.19-2.3 3.245a7.295 7.295 0 00-.832.153c-1.532.378-4.668 2.144-4.329 5.606.155 1.58 1.815 2.085 2.803 1.68.68-.28 1.13-.877 1.164-1.39 0 0-1.063.247-1.434-.963-.337-1.098.24-3.485 2.56-4.126-.001.187.002.38.013.58.032.602.088 1.074.15 1.535-.77.453-1.419.73-1.419.73l.012 1.225s.677-.347 1.534-.975c.094.798.167 1.778.144 3.42-.03 2.166-.208 3.457-.701 4.323l-.02-.008c-.776-.308-1.72-.684-2.295-.729-.852-.066-1.574.34-1.609 1.095-.02.44.093.944.847 1.34.784.41 2.08.439 3.417-.739.723.378 1.618.765 2.537.89 1.394.19 5.017-.619 6.045-4.784 1.145-4.64-2.274-7.777-5.162-8.619zm-1.135-2.068c.6.075.759.948.494 1.915a9.26 9.26 0 00-1.93-.154c.28-1.188.895-1.83 1.436-1.761zm-1.546 4.046a7.778 7.778 0 01-.024-1.402 5.38 5.38 0 011.73.114c-.044.082-.09.163-.14.243-.33.536-.906 1.03-1.502 1.444a3.851 3.851 0 01-.064-.4zm-2.178 10.68c-.823.503-1.62-.046-1.622-.49-.005-.607.668-.881 1.602-.466.124.056.312.165.55.304l.165.096a3.32 3.32 0 01-.695.555zm6.785-2.643c-.862 1.477-2.739 2.51-4.76 1.886.457-.562.993-1.433 1.666-2.951.976-2.202 1.336-3.999 1.336-3.999s-1.763-.248-2.526-1.812c.711-.615 1.436-1.385 1.948-2.28 1.755.652 2.963 2.286 3.23 4.447.176 1.432.09 3.025-.894 4.71z","fill":"#F0FDF4"}})])
          )
        }
      }
    